import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import PriceService from '../services/PriceService';

const initialState = {
  priceList: [],
  historyList: [],
  loading: false,
  submitLoading: false,
  pagination: {
    page: 1,
    per_page: 10,
    total: 0,
  },
  error: null,
};

export const fetchPriceList = createAsyncThunk(
  'price/fetchPriceList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await PriceService.FetchPriceList(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const changePrice = createAsyncThunk(
  'price/changePrice',
  async (data, { rejectWithValue }) => {
    try {
      const response = await PriceService.ChangePrice(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const importPriceList = createAsyncThunk(
  'price/importPriceList',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await PriceService.ImportPriceList(formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

const priceSlice = createSlice({
  name: 'price',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPriceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPriceList.fulfilled, (state, action) => {
        state.loading = false;
        state.priceList = action.payload.data.priceList;
        state.pagination = action.payload.data.pagination;
      })
      .addCase(fetchPriceList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to fetch price list';
      })
      .addCase(changePrice.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(changePrice.fulfilled, (state, action) => {
        state.submitLoading = false;
        toast.success(action.payload.message);
      })
      .addCase(changePrice.rejected, (state, action) => {
        state.submitLoading = false;
        toast.error(action.payload?.message || 'Failed to update price');
      })
      .addCase(importPriceList.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(importPriceList.fulfilled, (state, action) => {
        state.submitLoading = false;
        toast.success(action.payload.message);
      })
      .addCase(importPriceList.rejected, (state, action) => {
        state.submitLoading = false;
        toast.error(action.payload?.message || 'Failed to import prices');
      });
  },
});

export const priceSelector = (state) => state.price;
export default priceSlice.reducer;
